import { useState, useEffect } from "react";
import { api } from "../api";
import { useAuth } from "../AuthContext";

export default function Profilo() {
  const { utente } = useAuth();
  const [form, setForm]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [ok, setOk]           = useState(false);
  const [errore, setErrore]   = useState(null);

  // Cambio password
  const [pwForm, setPwForm]   = useState({ vecchia: "", nuova: "", conferma: "" });
  const [pwOk, setPwOk]       = useState(false);
  const [pwErr, setPwErr]     = useState(null);
  const [pwSaving, setPwSaving] = useState(false);

  useEffect(() => {
    api.getProfilo()
      .then(d => { setForm(d); setLoading(false); })
      .catch(e => { setErrore(e.message); setLoading(false); });
  }, []);

  const salva = async () => {
    setSaving(true); setErrore(null); setOk(false);
    try {
      await api.aggiornaProfilo(form);
      setOk(true);
    } catch (e) { setErrore(e.message); }
    setSaving(false);
  };

  const cambiaPw = async () => {
    if (pwForm.nuova !== pwForm.conferma) return setPwErr("Le password non coincidono");
    if (pwForm.nuova.length < 8) return setPwErr("Minimo 8 caratteri");
    setPwSaving(true); setPwErr(null); setPwOk(false);
    try {
      await api.changePassword(pwForm.vecchia, pwForm.nuova);
      setPwOk(true);
      setPwForm({ vecchia: "", nuova: "", conferma: "" });
    } catch (e) { setPwErr(e.message); }
    setPwSaving(false);
  };

  if (loading) return <div className="loading">Caricamento...</div>;

  return (
    <div className="page">
      <div className="page-header"><h1>Il mio profilo</h1></div>

      {/* ── Dati personali ─────────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">👤 Dati personali</h2>
        <p style={{ fontSize:12, color:"#64748b", marginBottom:20 }}>
          Questi dati appaiono nei preventivi che generi come "Redatto da".
        </p>

        {errore && <div className="errore-box">⚠️ {errore}</div>}
        {ok && <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, padding:"10px 16px", color:"#15803d", marginBottom:16 }}>✅ Profilo aggiornato</div>}

        <div className="form-grid">
          <div className="form-group span-2">
            <label className="form-label">Nome e Cognome *</label>
            <input className="form-input" value={form?.nome || ""}
              onChange={e => setForm({...form, nome: e.target.value})} />
          </div>
          <div className="form-group span-2">
            <label className="form-label">Email</label>
            <input className="form-input" value={form?.email || ""} disabled
              style={{ background:"#f8fafc", color:"#94a3b8" }} />
            <small style={{ color:"#94a3b8", fontSize:11 }}>L'email non è modificabile. Contatta l'amministratore.</small>
          </div>
          <div className="form-group span-2">
            <label className="form-label">Qualifica / Ruolo commerciale</label>
            <input className="form-input" value={form?.qualifica || ""}
              onChange={e => setForm({...form, qualifica: e.target.value})}
              placeholder="es. Responsabile Commerciale" />
          </div>
          <div className="form-group">
            <label className="form-label">Telefono diretto</label>
            <input className="form-input" value={form?.telefono || ""}
              onChange={e => setForm({...form, telefono: e.target.value})}
              placeholder="+39 0000 000000" />
          </div>
          <div className="form-group">
            <label className="form-label">Cellulare</label>
            <input className="form-input" value={form?.cellulare || ""}
              onChange={e => setForm({...form, cellulare: e.target.value})}
              placeholder="+39 333 0000000" />
          </div>
        </div>

        <div style={{ display:"flex", justifyContent:"flex-end", marginTop:20 }}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving ? "Salvataggio..." : "💾 Salva profilo"}
          </button>
        </div>
      </div>

      {/* ── Cambio password ────────────────────────────────────────────── */}
      <div className="card">
        <h2 className="card-title">🔑 Cambio password</h2>

        {pwErr && <div className="errore-box">⚠️ {pwErr}</div>}
        {pwOk && <div style={{ background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, padding:"10px 16px", color:"#15803d", marginBottom:16 }}>✅ Password aggiornata</div>}

        <div className="form-grid">
          <div className="form-group span-2">
            <label className="form-label">Password attuale</label>
            <input className="form-input" type="password" value={pwForm.vecchia}
              onChange={e => setPwForm({...pwForm, vecchia: e.target.value})} placeholder="••••••••" />
          </div>
          <div className="form-group">
            <label className="form-label">Nuova password</label>
            <input className="form-input" type="password" value={pwForm.nuova}
              onChange={e => setPwForm({...pwForm, nuova: e.target.value})} placeholder="Minimo 8 caratteri" />
          </div>
          <div className="form-group">
            <label className="form-label">Conferma nuova password</label>
            <input className="form-input" type="password" value={pwForm.conferma}
              onChange={e => setPwForm({...pwForm, conferma: e.target.value})} placeholder="Ripeti la password" />
          </div>
        </div>

        <div style={{ display:"flex", justifyContent:"flex-end", marginTop:20 }}>
          <button className="btn btn-primary" onClick={cambiaPw}
            disabled={pwSaving || !pwForm.vecchia || !pwForm.nuova || !pwForm.conferma}>
            {pwSaving ? "Aggiornamento..." : "🔑 Cambia password"}
          </button>
        </div>
      </div>

      {/* Info ruolo */}
      <div className="card" style={{ background:"#f8faff" }}>
        <div style={{ fontSize:12, color:"#64748b" }}>
          <strong>Ruolo assegnato:</strong> {form?.ruolo} &nbsp;—&nbsp;
          Per modificare il ruolo contatta l'amministratore.
        </div>
      </div>
    </div>
  );
}
